import React from 'react'
import Navbarmenu from './Navbarmenu';
import './UpcomingContent.css';
import Container from '@material-ui/core/Container';

 function UpcomingContent() {
    return (
        <>
            <div className="main-container" id="upcomingcontent-box">
                <title>Security Learning - Upcoming Events</title>
                <img src={process.env.PUBLIC_URL +"/images/Upcoming-events.jpg"} className="banner-img"/>
                <Navbarmenu/>
            </div>
            <Container className='upcoming-container' maxWidth="xl">
                <div className="upcoming-wrap">
                    <h3>Upcoming Events:</h3>
                    <p>Coming soon...</p>
                </div>
            </Container>
        </>
    )
}
export default UpcomingContent;